class HeroMediaSlideshow extends HTMLElement {
  constructor() {
    super();
    this.onSlideChange = this.onSlideChange.bind(this);
  }

  connectedCallback() {
    this.swiperHost = this.querySelector('swiper-slideshow');
    if (this.swiperHost) {
      this.swiperHost.addEventListener('swiper:slideChange', this.onSlideChange);
    }

    this.waitForActiveSlide().then(() => {
      this.syncActiveSlideVideos();
    });
  }

  waitForActiveSlide() {
    return new Promise(resolve => {
      const startedAt = Date.now();
      const check = () => {
        if (this.querySelector('.swiper-slide-active')) {
          resolve();
        } else if (Date.now() - startedAt >= 5000) {
          resolve();
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  }

  disconnectedCallback() {
    if (this.swiperHost) {
      this.swiperHost.removeEventListener('swiper:slideChange', this.onSlideChange);
    }
  }

  onSlideChange() {
    this.syncActiveSlideVideos();
  }

  syncActiveSlideVideos() {
    const slides = this.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      const video = slide.querySelector('.image-banner__media__video');
      if (!video) return;

      if (slide.classList.contains('swiper-slide-active')) {
        this.initVideo(video);
      } else {
        video.pause();
      }
    });
  }

  initVideo(video) {
    const revealAndPlay = () => {
      video.classList.add('is-loaded');

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    };

    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      revealAndPlay();
      return;
    }

    video.addEventListener('canplay', revealAndPlay, { once: true });
    video.addEventListener('loadeddata', revealAndPlay, { once: true });
    video.load();
  }
}

if (!customElements.get('hero-media-slideshow')) {
  customElements.define('hero-media-slideshow', HeroMediaSlideshow);
}
